import If from 'global/ErrorHandlers/If';
import { useEffect } from 'react';
import shallow from 'zustand/shallow';
import useOpeningAccountStore from 'global/Securities/stores/useOpeningAccountStore';
import LoginTradingModal from './LoginTradingModal';
import ProgressAuthModal from './ProgressAuthModal';
import RegisterTradingModal from './RegisterTradingModal';
import RejectedAuthModal from './RejectedAuthModal';
import { AuthModalStatus } from './types';
import useAuthModalStore from './store';

export default function AuthModal() {
  const authModalVisible = useAuthModalStore((s) => s.visible);
  const [oaStatus, loadAccountStatus] = useOpeningAccountStore(
    (s) => [s.status, s.loadAccountStatus],
    shallow,
  );

  useEffect(() => {
    loadAccountStatus();
  }, [loadAccountStatus]);

  const accountNotRegistered = [
    AuthModalStatus.UNREGISTERED,
    AuthModalStatus.INCOMPLETE,
  ].includes(oaStatus);

  const accountOnProgress = [
    AuthModalStatus.CS,
    AuthModalStatus.KSEI,
    AuthModalStatus.RDN,
  ].includes(oaStatus);

  return (
    <If condition={authModalVisible}>
      <If condition={accountNotRegistered}>
        <RegisterTradingModal visible={accountNotRegistered} />
      </If>

      <If condition={accountOnProgress}>
        <ProgressAuthModal visible={accountOnProgress} />
      </If>

      <If condition={oaStatus === AuthModalStatus.REJECTED}>
        <RejectedAuthModal visible={oaStatus === AuthModalStatus.REJECTED} />
      </If>

      <If condition={oaStatus === AuthModalStatus.COMPLETED}>
        <LoginTradingModal visible={oaStatus === AuthModalStatus.COMPLETED} />
      </If>
    </If>
  );
}
